export const CONSUMER_CODE_KEY = 'consumerCode';
